import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from '@enviroment/environment';
import { fadeInOutAnimation } from '@class/animations/animations';
import { SessionStorageUtil } from '@utils/sessionStorage';
import { title } from 'process';

@Component({
  selector: 'app-widget-event-bonus',
  templateUrl: './widget-event-bonus.component.html',
  styleUrl: './widget-event-bonus.component.css',
  animations: [fadeInOutAnimation]
})
export class WidgetEventComponent implements OnInit, OnChanges {
  private _amount: number = 0;
  @Input() set amount(value: number | string) {
    this._amount = typeof value === 'string' ? Number(value) : value;
  }
  get amount(): number {
    return this._amount;
  }

  @Input() term!: number;
  @Input() rate!: number;
  @Input() mobileDevice!: boolean;

  env = environment;
  eventBonus: string = '';
  show: boolean = false;
  deviceMobile?: boolean = false;
  isBono03Influencers: boolean = false;
  isBono03Apply: boolean = false;

  events: any = {
    MONEYCON: {
      minInitialAmount: 1000000,
      amountBenefit: 0,
      amountTotal: 0,
      amountGenerate: 0
    },
    BONO_SHERPATIAN: {
      minInitialAmount: 1000000,
      amountBenefit: 0,
      amountTotal: 0,
      amountGenerate: 0
    },
    BONO_EXITO_FINANCIERO: {
      minInitialAmount: 1000000,
      amountBenefit: 0,
      amountTotal: 0,
      amountGenerate: 0
    }
  }

  promo_bono_03_apply: any = [
    "MONEYCON",
    "BONO_SHERPATIAN",
    "BONO_EXITO_FINANCIERO",
    "GOFEST"
  ];

  promo_bonos_03_influencers: any = [
    "BONO_SHERPATIAN",
    "BONO_EXITO_FINANCIERO"
  ];

  messages_bono_03: any = {
    MONEYCON: {
      title: "asistir a la <b>Moneycon</b>",
    },
    BONO_SHERPATIAN: {
      title: "ser <b>Sherpa Financiero</b>",
    },
    BONO_EXITO_FINANCIERO: {
      title: "ser parte de <b>Éxito Financiero</b>",
    }
  }

  constructor(
    public sessionstorage: SessionStorageUtil,
  ) { }

  ngOnInit(): void {
    this.isBono03Apply = this.promo_bono_03_apply.includes(this.sessionstorage.get("event_bonus"));
    this.isBono03Influencers = this.promo_bonos_03_influencers.includes(this.sessionstorage.get("event_bonus"));
    this.eventBonus = this.sessionstorage.get('event_bonus') || '';
    this.handleInputsChange();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasChanges = Object.keys(changes).some(key => changes[key]);
    if (hasChanges) {
      this.handleInputsChange();
    }
  }

  handleInputsChange(): void {
    switch (this.eventBonus) {
      case 'MONEYCON':
      case 'BONO_SHERPATIAN':
      case 'BONO_EXITO_FINANCIERO':
        this.calculateMoneycon();
        break;

      default:
        break;
    }
  }

  calculateMoneycon(): void {
    if (this.eventBonus) {
      this.show = (this.amount >= this.events[this.eventBonus].minInitialAmount);

      const decimalRate = 0.3 / 100;
      const rate = Math.pow(1 + decimalRate, this.term / 12) - 1;

      this.events[this.eventBonus].amountBenefit = Math.round(rate * this.amount);
      this.events[this.eventBonus].amountTotal = this.amount + this.events[this.eventBonus].amountBenefit;

      /* Calcular rentabilidad con el nuevo monto */
      const amount = this.events[this.eventBonus].amountTotal;
      const rateEA = this.rate / 100;
      const years = this.term / 12;
      const amountGenerate = amount * Math.pow(1 + rateEA, years);

      this.events[this.eventBonus].amountGenerate = Math.round(amountGenerate);
    }
  }

}
